import { Components, Theme } from '@mui/material/styles'
import { LinkBehavior } from './navigation'

export const inputsCustomizations: Components<Theme> = {
  MuiButtonBase: {
    defaultProps: {
      disableTouchRipple: true,
      disableRipple: true,
      LinkComponent: LinkBehavior,
    },
    styleOverrides: {
      root: () => ({
        boxSizing: 'border-box',
        transition: 'all 100ms ease-in',
      }),
    },
  },
  MuiButton: {
    styleOverrides: {
      root: () => ({
        textTransform: 'none',
      }),
    },
  },
}
